import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/core-engine/page.tsx");
